import { SessionStatus } from '@/API';
import PlayerCanvas from '@/components/Player/PlayerCanvas';
import PlayerSpotlight from '@/components/Player/PlayerSpotlight';
import NoSleepProvider from '@/hooks/NoSleep';
import { useSession } from '@/hooks/PlayerSessionControlHooks';
import DemoSessionProvider from '@/providers/DemoSessionProvider';
import { Link } from 'react-router-dom';

/**
 * Demo game: draw, submit, then see your drawing spotlighted and react to it.
 *
 * Requires no Scribl account, no API, and no database. This exists so the Zoom
 * integration and the drawing experience can be tested independently of backend
 * access, using the real gameplay components rather than stand-ins.
 */

const DEMO_PROMPT = 'Draw something that made you smile this week';

function DemoStage() {
  const session = useSession();

  if (session?.status === SessionStatus.sharing) {
    return <PlayerSpotlight isSharing={false} />;
  }

  return <PlayerCanvas promptText={DEMO_PROMPT} />;
}

export default function ZoomDemo() {
  return (
    <NoSleepProvider>
      <div className="relative h-screen overflow-y-auto">
        <DemoSessionProvider>
          <DemoStage />
        </DemoSessionProvider>

        <Link
          to="/zoom"
          className="text-body text-body-xs absolute top-8 left-8 z-100 rounded-xs bg-white/80 px-8 py-4 text-neutral-500"
        >
          Exit demo
        </Link>
      </div>
    </NoSleepProvider>
  );
}
